import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { LocaleService } from "../locale/locale-service";

@Injectable({
  providedIn: "root"
})
export class SnackbarService {

  static readonly CAN_USE_ONLY_APP = '앱에서만 사용 가능합니다.';

  static readonly LOGIN_FAILED = '로그인에 실패했습니다. 다시 시도해 주세요.';
  static readonly LOGIN_NEEDED_MBTI_QUIZ = '성격 유형 퀴즈를 만들기 위해서는 로그인이 필요합니다.';
  static readonly LOGIN_NEEDED_SIGNAL = '시그널을 시작하기 위해서는 로그인이 필요합니다.';
  static readonly LOGIN_NEEDED = '로그인이 필요합니다.';
  static readonly USER_NOT_FOUND = '회원 정보를 불러오는데 실패했습니다. 다시 시도해 주세요.';

  static readonly FAIL_LOAD_FRIEND_LIST = '친구 목록을 불러오는데 실패했습니다. 다시 시도해 주세요.';
  static readonly NOT_AGREED_CONTACTS = '먼저 연락처 권한을 허용해주세요.';
  static readonly NOT_AGREED_SEARCH_FRIEND = '먼저 친구 찾기 기능을 켜주세요.';

  static readonly NOT_ANSWERED_NAME = '이름을 입력해 주세요.';
  static readonly NOT_ANSWERED_QUESTION = '응답하지 않은 질문이 있습니다.';
  static readonly NOT_ANSWERED_PHONE = '연락처를 입력해 주세요.';
  static readonly NOT_ANSWERED_EMAIL = '이메일을 입력해 주세요.';
  static readonly WRONG_INPUT_YEAR = '올바른 연도를 입력해주세요.';
  static readonly WRONG_INPUT_PHONE = '올바른 연락처를 입력해주세요.';
  static readonly INPUT_OTHERS_PHONE = '상대의 연락처를 입력해주세요.';
  static readonly SAVE_SUCCEED = '저장되었습니다.';

  static readonly NOT_ENOUGH_REPLACABLE_EXAMPLES = '더 이상 교체할 선택지가 없습니다.';
  static readonly EXAMPLE_REPLACED = '선택지가 교체되었습니다.';

  static readonly DELETED_HOST_QUIZ_REPORT = '삭제된 퀴즈입니다.';
  static readonly DELETED_GUEST_QUIZ_REPORT = '삭제된 응답입니다.';

  static readonly ALARM_SETTING_CHANGED = '알림 설정이 변경되었습니다.';

  static readonly SHARE_LINK_SUCCEED = '링크 공유에 성공했습니다.';
  static readonly SHARE_LINK_FAILED = '링크 공유에 실패했습니다.';
  static readonly CREATE_SHARE_LINK_DATA_FAILED = '공유 정보 생성에 실패했습니다.';
  static readonly SHARE_LINK_COPIED = '링크가 복사되었습니다.';

  static readonly DELETE_SUCCEED = '삭제 되었습니다.';
  static readonly DELETE_EMAIL_SUCCEED = '이메일이 삭제되었습니다.';
  static readonly DELETE_PHONE_SUCCEED = '연락처가 삭제되었습니다.'
  static readonly DELETE_ANSWER_SUCCEED = '응답이 삭제되었습니다.';
  static readonly DELETE_FAILED = '삭제에 실패했습니다.';
  static readonly ERROR = '오류가 발생했습니다. 다시 시도해 주세요.';
  static readonly CHANGE_SETTING_FAILED = '설정 변경에 실패했습니다. 다시 시도해 주세요.';

  static readonly UPDATE_FAILED = '업데이트가 실패했습니다. 잠시 후 다시 시도합니다.';

  static readonly QUIZ_REPORT_NAME_CHANGED = '이제 변경된 이름으로 표시됩니다.';

  static readonly NOT_PERMITTED = '해당 페이지를 조회할 권한이 없습니다.';

  static readonly PREPARING_LINK = '링크 생성 중 입니다. 잠시만 기다려 주세요.';
  static readonly NO_QUESTION_GROUP = '존재하지 않는 주제입니다.';

  static readonly ERROR_500 = '이런! 서버가 너무 바빠 요청을 처리할 수 없었습니다. 다시 시도해주세요.';
  static readonly ERROR_HOST_QUIZ_REPORT_EMPTY = '퀴즈를 생성 중입니다. 잠시 후 다시 확인해 주세요.';
  static readonly ERROR_GUEST_QUIZ_REPORT_EMPTY = '응답을 생성 중입니다. 잠시 후 다시 확인해 주세요.';
  static readonly ALREADY_WITHDREW = '탈퇴한 계정입니다.';
  static readonly NOT_PROPER_ACCESS = '잘못된 접근입니다.';

  static readonly AFTER_KAKAO_SYNC = '훌륭합니다 👍 이제 이전처럼 타입스를 즐기세요!';
  static readonly NEED_TO_ALLOW_CONTACT = '앱 설정에서 연락처 권한을 허용해주세요';
  static readonly CONTACT_PERMISSION_DENIED = '기기의 연락처에 접근할 권한이 없습니다. 다시 시도해 주세요.';

  // ask 기능
  static readonly CREATE_POST_FAILED = '게시글 생성에 실패했어요.';
  static readonly CREATE_COMMENT_FAILED = '댓글 생성에 실패했어요.';
  static readonly ASK_POST_DELETED = '게시글이 삭제되었습니다.';
  static readonly ASK_COMMENT_DELETED = '댓글이 삭제되었습니다.';
  static readonly ASK_REPORT_SUBMITTED = '신고가 접수되었습니다.';
  static readonly ASK_POST_CREATED = '게시글이 등록되었습니다.';
  static readonly ASK_COMMENT_CREATED = '댓글이 등록되었습니다.';
  static readonly CONTAINS_BADWORD = '사용할 수 없는 단어가 포함되었습니다.';

  // survey
  static readonly SURVEY_COMMENT_DELETED = '댓글이 삭제되었습니다.';
  static readonly SURVEY_REPORT_SUBMITTED = '신고가 접수되었습니다.';

  // tc
  static readonly TC_CONTENT_NOT_ENOUGH_LENGTH = '10자 이상 입력해 주세요.';


  // soulmate profile update
  static readonly INVALID_INPUT = '정보를 제대로 입력해주세요.';
  static readonly PROFILE_UPDATE_COMPLETE = '프로필이 저장되었습니다.'

  constructor(private snackbar: MatSnackBar, private localeService: LocaleService) {

  }

  openSnackBar(message: string, action?: string) {
    const localizedMessage = this.localeService.getLocaleString(message)
    const ref = this.snackbar.open(localizedMessage, action, {
      duration: 2000,
      panelClass: 'snackbar',
    });
  }
}
